import * as OfferActions from './offer.actions';
import {PageSettings} from '../../model/page-settings.model';
import {updateStateOfferWithBidDealerStatus, updateStateOfferWithBidGeneralStatus} from '../common-state-functions';
import {AUCTION_TYPES} from '../../misc/constants';

// This is the redux sub-store 'offer' defined by the interface State and its reducer function

/**
 * The interface defining the redux sub-store
 */
export interface StateOffer {
  offers: OfferDto[]; // currently not used
  offer: OfferDto; // the offer used for display in detail view
  bookmarkedOffersPIA: OfferDto[];
  bookmarkedOffersPB: OfferDto[];
  bookmarkedOffersALLUC: OfferDto[];
  bookmarkedOffersDINBIL: OfferDto[];
  bookmarkedOffersVGRX: OfferDto[];
  currentUserCompanyOffersPIA: OfferDto[];
  currentUserCompanyOffersPB: OfferDto[];
  currentUserCompanyOffersALLUC: OfferDto[];
  currentUserCompanyOffersDINBIL: OfferDto[];
  currentUserCompanyOffersVGRX: OfferDto[];
  finishedUserCompanyOffersPIA: OfferDto[];
  finishedUserCompanyOffersPB: OfferDto[];
  finishedUserCompanyOffersALLUC: OfferDto[];
  finishedUserCompanyOffersDINBIL: OfferDto[];
  finishedUserCompanyOffersVGRX: OfferDto[];
  settings: ViewTag[];
  pageSettings: PageSettings;
  auctionBid: number;
}

// default values - will be overridden at demand
const defaultPageSettings = new PageSettings();
defaultPageSettings.channel = 'ALL_UC';
defaultPageSettings.size = 25; // if changed please see for offering.component, too
defaultPageSettings.page = 0;
defaultPageSettings.sort = 'EXPIRATION';
defaultPageSettings.order = 'ASC';

/**
 * The reducer acts on actions as defined below, and is the only way to update state
 * The JS spread operator for objects ('...') is used to update a given property of our state
 * while leaving the remaining properties of the state unchanged
 *
 * @param {StateOffer} state: the initial state of the redux sub-store
 * @param {OfferAction} action: the actions that this sub-store is managing
 * @returns {any} updated state of the redux sub-store
 */
export function offerReducer(state: StateOffer = {
  offer: undefined,
  offers: undefined,
  bookmarkedOffersPIA: undefined,
  bookmarkedOffersPB: undefined,
  bookmarkedOffersALLUC: undefined,
  bookmarkedOffersDINBIL: undefined,
  bookmarkedOffersVGRX: undefined,
  currentUserCompanyOffersPIA: undefined,
  currentUserCompanyOffersPB: undefined,
  currentUserCompanyOffersALLUC: undefined,
  currentUserCompanyOffersDINBIL: undefined,
  currentUserCompanyOffersVGRX: undefined,
  finishedUserCompanyOffersPIA: undefined,
  finishedUserCompanyOffersPB: undefined,
  finishedUserCompanyOffersALLUC: undefined,
  finishedUserCompanyOffersDINBIL: undefined,
  finishedUserCompanyOffersVGRX: undefined,
  settings: undefined,
  pageSettings: defaultPageSettings,
  auctionBid: undefined
},
action: OfferActions.OfferAction) {
  switch (action.type) {
  case OfferActions.UPDATED_OFFER:
    return {
      ...state,
      offer: action.payload // update our stored offerDto with the action's payload
    };
  case OfferActions.UPDATED_BOOKMARKED_OFFERS_PIA:
    return {
      ...state,
      bookmarkedOffersPIA: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_BOOKMARKED_OFFERS_PB:
    return {
      ...state,
      bookmarkedOffersPB: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_BOOKMARKED_OFFERS_ALLUC:
    return {
      ...state,
      bookmarkedOffersALLUC: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_BOOKMARKED_OFFERS_DINBIL:
    return {
      ...state,
      bookmarkedOffersDINBIL: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_BOOKMARKED_OFFERS_VGRX:
    return {
      ...state,
      bookmarkedOffersVGRX: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_CURRENT_USERCOMPANY_OFFERS_PIA:
    return {
      ...state,
      currentUserCompanyOffersPIA: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_CURRENT_USERCOMPANY_OFFERS_PB:
    return {
      ...state,
      currentUserCompanyOffersPB: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_CURRENT_USERCOMPANY_OFFERS_ALLUC:
    return {
      ...state,
      currentUserCompanyOffersALLUC: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_CURRENT_USERCOMPANY_OFFERS_DINBIL:
    return {
      ...state,
      currentUserCompanyOffersDINBIL: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_CURRENT_USERCOMPANY_OFFERS_VGRX:
    return {
      ...state,
      currentUserCompanyOffersVGRX: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_FINISHED_USERCOMPANY_OFFERS_PIA:
    return {
      ...state,
      finishedUserCompanyOffersPIA: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_FINISHED_USERCOMPANY_OFFERS_PB:
    return {
      ...state,
      finishedUserCompanyOffersPB: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_FINISHED_USERCOMPANY_OFFERS_ALLUC:
    return {
      ...state,
      finishedUserCompanyOffersALLUC: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_FINISHED_USERCOMPANY_OFFERS_DINBIL:
    return {
      ...state,
      finishedUserCompanyOffersDINBIL: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATED_FINISHED_USERCOMPANY_OFFERS_VGRX:
    return {
      ...state,
      finishedUserCompanyOffersVGRX: action.payload // update our stored offerDtos with the action's payload
    };
  case OfferActions.UPDATE_VIEW_SETTINGS:
    return {
      ...state,
      settings: action.settings // update our stored viewSettings with the action's payload
    };
  case OfferActions.UPDATE_PAGE_SETTINGS:
    return {
      ...state,
      pageSettings: action.payload
    };
  case OfferActions.UPDATE_PAGE_SETTINGS_PAGE:
    return {
      ...state,
      pageSettings: {
        ...state.pageSettings,
        page: action.page
      }
    };
  case OfferActions.UPDATE_PAGE_SETTINGS_CHANNEL:
    return {
      ...state,
      pageSettings: {
        ...state.pageSettings,
        channel: action.channel
      }
    };
  case OfferActions.UPDATE_BID_STATUS:
    return updateStateWithBidStatus(state, action.payload);
  case OfferActions.UPDATE_BID_STATUS_GENERAL:
    return updateStateOfferWithBidGeneralStatus(state, action.payload);
  case OfferActions.UPDATE_BID_STATUS_DEALER_SPECIFIC:
    return updateStateOfferWithBidDealerStatus(state, action.payload);
  case OfferActions.UPDATE_AUCTION_BID:
    return {
      ...state,
      auctionBid: action.payload
    };
  default:
    return state;
  }
}

/**
 * @deprecated remove when UCS_539_SPLIT_WS_BID_STATUS_MESSAGE is removed
 *
 * Update offer state with new bid status information.
 *
 * Only the current distribution channel is updated, as other channels will be newly fetched from backend on change.
 *
 * @param state the offer state to update
 * @param bidStatus the bid status to update the offer state with
 *
 * @return the update offer state
 */
function updateStateWithBidStatus(state: StateOffer, bidStatus: BidStatusDto): StateOffer {

  // as other channels will be newly fetched anyway, there is no need to update bid status for them
  // only update the currently selected channel
  switch (state.pageSettings.channel) {
  case 'PIA':
    updateOfferInOffers(state.bookmarkedOffersPIA, bidStatus);
    updateOfferInOffers(state.finishedUserCompanyOffersPIA, bidStatus);
    updateOfferInOffers(state.currentUserCompanyOffersPIA, bidStatus);
    break;
  case 'PB':
    updateOfferInOffers(state.bookmarkedOffersPB, bidStatus);
    updateOfferInOffers(state.finishedUserCompanyOffersPB, bidStatus);
    updateOfferInOffers(state.currentUserCompanyOffersPB, bidStatus);
    break;
  case 'ALL_UC':
    updateOfferInOffers(state.bookmarkedOffersALLUC, bidStatus);
    updateOfferInOffers(state.finishedUserCompanyOffersALLUC, bidStatus);
    updateOfferInOffers(state.currentUserCompanyOffersALLUC, bidStatus);
    break;
  case 'DIN_BIL':
    updateOfferInOffers(state.bookmarkedOffersDINBIL, bidStatus);
    updateOfferInOffers(state.finishedUserCompanyOffersDINBIL, bidStatus);
    updateOfferInOffers(state.currentUserCompanyOffersDINBIL, bidStatus);
    break;
  case 'VGRX':
    updateOfferInOffers(state.bookmarkedOffersVGRX, bidStatus);
    updateOfferInOffers(state.finishedUserCompanyOffersVGRX, bidStatus);
    updateOfferInOffers(state.currentUserCompanyOffersVGRX, bidStatus);
    break;
  default:
      // no channel set, disregard update
  }

  // try updating a detail view's offer
  if (state.offer && state.offer.id === bidStatus.offerId && AUCTION_TYPES.includes(state.offer.offerType.data)) {
    setBidStatusState(bidStatus, state);
  }

  return state;
}

/**
 * @deprecated remove when UCS_539_SPLIT_WS_BID_STATUS_MESSAGE is removed
 */
function setBidStatusState(bidStatus: BidStatusDto, state: StateOffer) {
  if (bidStatus.bidStatus) {
    (state.offer as AuctionOfferDto | EnforcedAuctionOfferDto).bidStatus = bidStatus.bidStatus;
  }
  if (bidStatus.expiration) {
    (state.offer as AuctionOfferDto | EnforcedAuctionOfferDto).expiration = bidStatus.expiration;
  }
  if (bidStatus.highestBid) {
    (state.offer as AuctionOfferDto | EnforcedAuctionOfferDto).highestBid = bidStatus.highestBid;
  }
  if (bidStatus.maximumBid) {
    (state.offer as AuctionOfferDto | EnforcedAuctionOfferDto).maximumBid = bidStatus.maximumBid;
  }
  if (bidStatus.myLastHighestBid) {
    (state.offer as AuctionOfferDto | EnforcedAuctionOfferDto).myLastHighestBid = bidStatus.myLastHighestBid;
  }
  if (bidStatus.myLastMaximumBid) {
    (state.offer as AuctionOfferDto | EnforcedAuctionOfferDto).myLastMaximumBid = bidStatus.myLastMaximumBid;
  }
  if (bidStatus.minimumBid) {
    (state.offer as AuctionOfferDto | EnforcedAuctionOfferDto).minimumBid = bidStatus.minimumBid;
  }
}

/**
 * @deprecated remove when UCS_539_SPLIT_WS_BID_STATUS_MESSAGE is removed
 *
 * Updates an offer of our (sub-)state with the updated information from bid status dto.
 *
 * @param offers    the offer dto array containing the auction offer to update
 * @param bidStatus the new bid status to update the auction offer with
 */
function updateOfferInOffers(offers: OfferDto[], bidStatus: BidStatusDto) {
  if (offers) {
    // find the offer we want to update
    const offerToUpdate = offers['content']
      .find(offer => offer.id === bidStatus.offerId && AUCTION_TYPES.includes(offer.offerType.data));

    if (offerToUpdate) {
      setBidStatusOfferToUpdate(bidStatus, offerToUpdate);
    }
  }
}

/**
 * @deprecated remove when UCS_539_SPLIT_WS_BID_STATUS_MESSAGE is removed
 */
function setBidStatusOfferToUpdate(bidStatus: BidStatusDto, offerToUpdate) {
  if (bidStatus.bidStatus) {
    offerToUpdate.bidStatus = bidStatus.bidStatus;
  }
  if (bidStatus.expiration) {
    offerToUpdate.expiration = bidStatus.expiration;
  }
  if (bidStatus.highestBid) {
    offerToUpdate.highestBid = bidStatus.highestBid;
  }
  if (bidStatus.maximumBid) {
    offerToUpdate.maximumBid = bidStatus.maximumBid;
  }
  if (bidStatus.myLastHighestBid) {
    offerToUpdate.myLastHighestBid = bidStatus.myLastHighestBid;
  }
  if (bidStatus.myLastMaximumBid) {
    offerToUpdate.myLastMaximumBid = bidStatus.myLastMaximumBid;
  }
  if (bidStatus.minimumBid) {
    offerToUpdate.minimumBid = bidStatus.minimumBid;
  }
}
